import type { ProgramOption } from 'types';

interface ProgramListItem {
    program_name: string;
    display_color?: string;
}

export const getScoreColor = (score: number, maxScore: number): string => {
    if (!maxScore) return 'success.main';
    const pct = score / maxScore;
    if (pct >= 0.85) return 'success.main';
    if (pct >= 0.7) return 'warning.main';
    return 'error.main';
};

export const toPercent = (score: number, maxScore: number): number | null => {
    if (!maxScore) return null;
    return Math.round((100 * score) / maxScore);
};

export const mapProgramListResponse = (data: unknown): ProgramOption[] => {
    if (!Array.isArray(data) || data.length === 0) {
        return [];
    }

    const first = data[0];
    if (typeof first === 'object' && first !== null && 'program_name' in first) {
        return (data as ProgramListItem[]).map((item) => ({
            value: item.program_name,
            label: item.program_name,
            display_color: item.display_color,
        }));
    }

    return (data as string[]).map((programName) => ({
        value: programName,
        label: programName,
    }));
};
